import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

interface BarChartData {
  name: string;
  value: number;
}

interface DashBoardBarChartProps {
  data?: BarChartData[];
}

const DashBoardBarChart: React.FC<DashBoardBarChartProps> = ({ data = [] }) => {
  return (
    <div style={{ width: "100%", height: 300 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 5, right: 0, left: 0, bottom: 5 }}>
          <CartesianGrid vertical={false} stroke="#F2F4F7" strokeDasharray="0" />
          <XAxis
            dataKey="name"
            tick={{ fill: "#344054", fontSize: 14 }}
            axisLine={{ stroke: "#F2F4F7" }}
            tickLine={false}
          />
          <YAxis
            width={32}
            tick={{ fill: "#344054", fontSize: 14 }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip
            formatter={(value) => [value, "명"]}
            contentStyle={{
              backgroundColor: "#fff",
              border: "1px solid #D9D9D9",
              borderRadius: 8,
              padding: "8px 10px",
              color: "#4B566C",
              boxShadow: "0 8px 24px rgba(16, 24, 40, 0.14)",
            }}
            labelStyle={{ color: "#4B566C", fontSize: 16 }}
            itemStyle={{ color: "#4B566C", fontSize: 16, fontWeight: 900 }}
            cursor={false}
          />
          <Bar
            dataKey="value"
            fill="#E9EDF4"
            activeBar={{ fill: "#2D91FF" }}
            barSize={16}
            radius={[8, 8, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default DashBoardBarChart;
